import React, {useEffect, useReducer, useRef, useState} from "react";
import {useLocation} from "react-router-dom";
import {Box} from "@chakra-ui/react";
import {verifyUser} from "../../authRequests";
import {patientReducer, init} from "../../additional_files/reducer";
import Layout from "../Layout";

// The route-level switch between a guardian's own screen and a dependent's.
//
// It exists so the ordinary portal screens never have to ask whose record they
// are showing. They always show the signed-in person's own — `state.patient` is
// the account holder and stays that way for the whole session, including while
// a dependent is active. A dependent's data reaches the screen only through a
// component mounted here, which fetches it from an endpoint that names the
// dependent in the path.
//
// That is the property worth having: if this switch ever fails, the failure
// shows the guardian THEIR OWN data. The previous design put the dependent into
// `state.patient` and re-ran the generic loader with that pid, so the same
// failure showed somebody else's record — and every screen in the app, reached
// by any route, was a potential disclosure.
//
// The switch itself holds no hooks beyond reading the route, so mounting a
// self screen through it costs nothing: no second reducer, no second session
// check.

export default function DependentRoute({section, self: SelfScreen, dependent: DependentScreen}) {
  const {state} = useLocation();
  if (!state?.viewingDependent) return <SelfScreen />;
  return <DependentScreenHost section={section} screen={DependentScreen} />;
}

function DependentScreenHost({section, screen: Screen}) {
  const {state} = useLocation();
  const loadedRef = useRef(null);
  const [dashState, dispatch] = useReducer(patientReducer, state, init);
  const [prevState, setPrevState] = useState(state);

  useEffect(() => {
    verifyUser(state ? state.jwt : "", loadedRef);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (prevState !== state) {
    setPrevState(state);
    dispatch({type: "UPDATE_STATE", payload: state});
  }

  return (
    <Layout state={{...dashState}} dispatch={dispatch}>
      <Box display="flex" flex={1} overflow="auto" flexDirection="column" w="100%">
        <Screen state={dashState} dispatch={dispatch} section={section} />
      </Box>
    </Layout>
  );
}
